import { render, staticRenderFns } from "./EditWholesaleOrder.vue?vue&type=template&id=f35345ea&scoped=true&"
import script from "./EditWholesaleOrder.vue?vue&type=script&lang=js&"
export * from "./EditWholesaleOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditWholesaleOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditWholesaleOrder.vue?vue&type=style&index=1&id=f35345ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35345ea",
  null
  
)

export default component.exports